export const setCookie = ({
  name,
  value,
  days,
  minutes,
}: {
  name: string;
  value: string;
  days?: number;
  minutes?: number;
}) => {
  let expires = "";
  let maxAge = "";

  const durationInMinutes = days ? days * 24 * 60 : minutes;

  if (durationInMinutes) {
    const expiryDate = new Date(Date.now() + durationInMinutes * 60 * 1000);
    expires = `; expires=${expiryDate.toUTCString()}`;
    maxAge = `; max-age=${durationInMinutes * 60}`;
  }

  const cookieString = `${name}=${value}${expires}${maxAge}; path=/; SameSite=Lax`;
  // biome-ignore lint/suspicious/noDocumentCookie: <Need to set cookie for specific domain>
  document.cookie = cookieString;
};

export const getCookie = (name: string) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const deleteCookie = (
  name: string,
  path = "/",
  domain = "storydoc.com",
) => {
  if (!getCookie(name)) return;

  // Delete cookie for specific domain if not localhost
  if (
    domain &&
    window.location.hostname !== "localhost" &&
    window.location.hostname !== "127.0.0.1"
  ) {
    // biome-ignore lint/suspicious/noDocumentCookie: <Need to delete cookie for specific domain>
    document.cookie = `${name}=;${path ? `path=${path};` : ""}domain=${domain};expires=Thu, 01 Jan 1970 00:00:01 GMT`;
  }

  // biome-ignore lint/suspicious/noDocumentCookie: <Need to delete cookie for fallback>
  document.cookie = `${name}=;${path ? `path=${path};` : ""}expires=Thu, 01 Jan 1970 00:00:01 GMT`;
};
